var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device",class:'device--' + _vm.device.getModifier()},[_c('div',{staticClass:"device-screenshot",class:'device-screenshot--' + _vm.device.getModifier(),style:(_vm.device.getStyle())})])}
var staticRenderFns = []

export { render, staticRenderFns }